import { Component, Injectable, Type } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Dialog {
    name: string;
    params?: any,
    component?: Type<Component>,
    callback?: Function;
}

export interface IFunctionCall {
    function: string;
    object?: any;
}

@Injectable({
    providedIn: 'root'
})
export class DialogService {
    dialog$ = new BehaviorSubject<Dialog | null>(null);
    closeDialog$ = new BehaviorSubject(null);
}
